import React from 'react'
import classnames from "classnames";
import { Collapse } from 'reactstrap';
import { getPrimaryTextClass } from 'helpers/sf_utils';
import LeadMacrosTableBody from './LeadMacrosTableBody';

const FILTER_CONSTANTS = ["Drivers", "Vehicles", "Violations", "Claims", "Driver Accidents"];

const getFiltersLeadIntegration = (category, constants) => category?.lead_integration_macros.filter(macro => ((macro.display_key !== category.name) && (!constants.includes(macro.display_key))))

/**
 * @param {number} props.index index of the current category
 * @param {boolean} props.lastIndex true if the current category is the last category, false otherwise
 * @param {object} props.category current category object (sf_macro_category)
 * @param {Array} props.checked_macro_Key_stats Array with keys of macros selected
 * @param {boolean} props.openAccordionState true if the category accordion should be expanded, false otherwise
 * @param {function} props.setOpenAccordionState function to set the accordion state
 * @param {function} props.launchFormatterModal (macro) => { // opens the macro formatting modal for that macro }
 * @param {function} props.launchMappingModal (macro) => { // opens the macro mapping modal for that macro }
 * @param {function} props.duplicateMacrosMapping (macro) => { // duplicates the macro }
 * @param {boolean} [props.readOnly] hide the macro actions (format, mapping, duplicate)
 * @returns {ReactElement}
 */
const LeadMacrosTable = ({ index, lastIndex, category, checked_macro_Key_stats, openAccordionState, setOpenAccordionState, launchFormatterModal, launchMappingModal, duplicateMacrosMapping, readOnly = false }) => {
    const toggleAccordionStateById = (id) => {
        setOpenAccordionState(prevAccordion => {
            return prevAccordion.map(single_category => (single_category.id === id) ? ({...single_category, active: !single_category.active}) : single_category)
        })
    }

    const getOpenAccordionStateById = (id) => {
        return !!openAccordionState.find(acc => acc.id === id)?.active
    }

    return (
        <div className={`accordion-item bg-white border-top-0 border-start-0 border-end-0 ${lastIndex ? "border-bottom-0" : ""}`}>
            <h2 className="accordion-header" id={`lead_macro_heading_${index}`}>
                <button
                    className={classnames("accordion-button bg-white border-0", "text-black", "shadow-none", "font-weight-semibold px-2", { collapsed: !getOpenAccordionStateById(category.id) })}
                    type="button"
                    onClick={() => toggleAccordionStateById(category.id)}>
                    {category.name}
                </button>
            </h2>
            <Collapse isOpen={getOpenAccordionStateById(category.id)} className="accordion-collapse" cssModule={{color: "#000000"}}>
                <div className="accordion-body p-0">
                    {category?.sub_categories?.map((sub_category, sub_category_index) => {
                        return (
                            <div className={`accordion-item bg-white ${sub_category_index === 0 ? "" : "border-top-0"} border-start-0 border-end-0`}>
                                <h2 className="accordion-header" id={`lead_sub_category_macro_heading_${sub_category_index}`}>
                                    <button
                                        className={classnames("accordion-button bg-white border-0", "text-black", "shadow-none", "d-flex", "align-items-center", { collapsed: !getOpenAccordionStateById(sub_category.id) })}
                                        type="button"
                                        onClick={() => toggleAccordionStateById(sub_category.id)}>
                                        <i className={`bx ${getPrimaryTextClass()} me-2 font-size-13 bx-subdirectory-right`} />
                                        <span>{sub_category.name}</span>
                                    </button>
                                </h2>
                                <Collapse isOpen={getOpenAccordionStateById(sub_category.id)} className="accordion-collapse">
                                    <div className="accordion-body p-0">
                                        {sub_category?.lead_integration_macros?.length > 0 && getFiltersLeadIntegration(sub_category, FILTER_CONSTANTS).map((macro, sub_category_macro_index) => {
                                          return (<LeadMacrosTableBody
                                                key={macro.id}
                                                index={sub_category_macro_index}
                                                isLastIndex={sub_category_macro_index === getFiltersLeadIntegration(sub_category, FILTER_CONSTANTS).length - 1}
                                                macro={macro}
                                                checked_macro_Key_stats={checked_macro_Key_stats}
                                                launchFormatterModal={launchFormatterModal}
                                                launchMappingModal={launchMappingModal}
                                                duplicateMacrosMapping={duplicateMacrosMapping}
                                                readOnly={readOnly}
                                            />)
                                        })}
                                    </div>
                                </Collapse>
                            </div>
                        )
                    })}
                    {category?.lead_integration_macros?.length > 0 && getFiltersLeadIntegration(category, FILTER_CONSTANTS).map((macro, category_macro_index) => {
                        return (<LeadMacrosTableBody
                            key={macro.id}
                            index={category_macro_index}
                            isLastIndex={category_macro_index === getFiltersLeadIntegration(category, FILTER_CONSTANTS).length - 1}
                            macro={macro}
                            checked_macro_Key_stats={checked_macro_Key_stats}
                            launchFormatterModal={launchFormatterModal}
                            launchMappingModal={launchMappingModal}
                            duplicateMacrosMapping={duplicateMacrosMapping}
                            readOnly={readOnly}
                        />)
                    })}
                </div>
            </Collapse>
        </div>
    )
}

export default LeadMacrosTable;
